import { render, staticRenderFns } from "./NonlipidEffects.vue?vue&type=template&id=2030ab2d&scoped=true"
import script from "./NonlipidEffects.vue?vue&type=script&lang=js"
export * from "./NonlipidEffects.vue?vue&type=script&lang=js"
import style0 from "./NonlipidEffects.vue?vue&type=style&index=0&id=2030ab2d&prod&lang=scss&scoped=true"
import style1 from "./NonlipidEffects.vue?vue&type=style&index=1&id=2030ab2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030ab2d",
  null
  
)

export default component.exports